<template>
  <div class="container">
    <div  v-for='(editablePageConfig,key) in editablePageConfigList' :key="key">
      <model1 v-if='editablePageConfig.editable_page_model_id==1' v-bind:editablePageConfig="editablePageConfig"></model1>
      <model2 v-if='editablePageConfig.editable_page_model_id==2' v-bind:editablePageConfig="editablePageConfig"></model2>
      <model6 v-if='editablePageConfig.editable_page_model_id==6' v-bind:editablePageConfig="editablePageConfig"></model6>
      <model12 v-if='editablePageConfig.editable_page_model_id==12' v-bind:editablePageConfig="editablePageConfig"></model12>
      <model13 v-if='editablePageConfig.editable_page_model_id==13' v-bind:editablePageConfig="editablePageConfig"></model13>
      <model14 v-if='editablePageConfig.editable_page_model_id==14' v-bind:editablePageConfig="editablePageConfig"></model14>
      <model15 v-if='editablePageConfig.editable_page_model_id==15' v-bind:editablePageConfig="editablePageConfig"></model15>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { getEditablePageConfigList } from '../../../api/homeindex'
import Model1 from './editable_page_model/Model1'
import Model2 from './editable_page_model/Model2'
import Model6 from './editable_page_model/Model6'
import Model12 from './editable_page_model/Model12'
import Model13 from './editable_page_model/Model13'
import Model14 from './editable_page_model/Model14'
import Model15 from './editable_page_model/Model15'
export default {
  name:'SpecialIndex',
  data () {
    return {
      editablePage:{},
      editablePageConfigList: []
    }
  },
  props:['pagePath','itemId'],
  components: {
    Model1,
    Model2,
    Model6,
    Model12,
    Model13,
    Model14,
    Model15
  },
  computed: {
    ...mapState({
      special: state => state.home.special
    }),

  },
  mounted () {
    window.onscroll = function () {
      // 为了保证兼容性，这里取三个值，哪个有值取哪一个
      // scrollTop就是触发滚轮事件时滚轮的高度
      let indexParamsScroll = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
      console.log(indexParamsScroll, 'zong总index滚动的高度')
      // 获取元素在页面中的位置
      // let indexParams = {
      //   // 滚动条位置
      //   scroll: indexParamsScroll
      // }
      // localStorage.setItem('indexParams', JSON.stringify(indexParams))
      // console.log('总index滚动距离' + indexParams.scroll)


    }
  },
  created: function () {
    // let createdParam = JSON.parse(localStorage.getItem('indexParams'))
    // console.log(createdParam, '总index----------index')
    // if (createdParam) {
    //   document.documentElement.scrollTop = createdParam.scroll // pc的移动端调试模式管用，真机上不行
    //   document.body.scrollTop = createdParam.scroll// 真机用这个！！！
    //     console.log(document.documentElement.scrollTop, document.body.scrollTop, '赋高度值-------indexindex------的的的的位置')
    // }

    var special_id = this.$route.query.special_id
    if (!special_id && !this.pagePath) {
      Toast('缺少参数')
      return
    }
    getEditablePageConfigList(special_id,this.pagePath,this.itemId).then(res => {
      this.editablePage = res.result.editable_page
      this.editablePageConfigList = res.result.editable_page_config_list
      if(this.pagePath){
        this.saveHomeSpecial({pagePath:this.pagePath,storeId:'',itemId:this.itemId,editablePage:this.editablePage,editablePageConfigList:this.editablePageConfigList})
      }
    }).catch(function (error) {
      Toast(error.message)
    })
  },

  methods: {
    ...mapMutations({
      saveHomeSpecial: 'saveHomeSpecial'
    }),
  }
}
</script>

<style scoped>

</style>
